import { VehicleForBookingResponse } from '../types/api.types'

export class FleetModel {
  costPerTime: { amount: number; currencyCode: 'GBP' }
  costPerUnit: { amount: number; currencyCode: 'GBP' }
  distanceUnit: string
  id: string
  image: string
  isActive: boolean
  luggageCapacity: number
  sittingCapacity: number
  timeUnit: string
  totalCost: { amount: number; currencyCode: 'GBP' }
  totalDistanceInMtr: number
  totalTimeInSec: number
  type: string
  vehicleName: string
  numberOfDoors: number
  transmissionType: string

  constructor(data: VehicleForBookingResponse) {
      // Converting from VehicleForBookingResponse
      // Use calculated price if available, otherwise use base price
      const priceToUse = data.fair.calculatedPrice || data.fair.basePrice

      this.costPerTime = {
        amount: priceToUse,
        currencyCode: 'GBP',
      }
      this.costPerUnit = {
        amount: priceToUse,
        currencyCode: 'GBP',
      }
      this.distanceUnit = 'km'
      this.id = data.id
      this.image = data.imageUrl || ''
      this.isActive = data.isActive
      this.luggageCapacity = this.getLuggageCapacity(data)
      this.sittingCapacity = data.seats
      this.timeUnit = 'hour'
      this.totalCost = {
        amount: priceToUse,
        currencyCode: 'GBP',
      }
      this.totalDistanceInMtr = 0 // Note: API now returns miles, but this field name suggests meters
      this.totalTimeInSec = 0
      this.type = data.segment.name
      this.vehicleName = data.name
      this.numberOfDoors = 4 // Default value
      this.transmissionType = data.transmission
  }

  getLuggageCapacity(data: VehicleForBookingResponse) {
    if (data?.segment?.name?.toLowerCase()?.includes('van')) {
      return 5
    }
    return 2
  }
}
